import React, { useEffect, useRef } from 'react';
import { Chart, ChartData, ChartOptions } from 'chart.js';
import styled from '@emotion/styled';

type Props = {
  data: ChartData<'radar'>;
  options: ChartOptions<'radar'>;
};

const StyledChart = styled.div`
  height: 250px;
`;

const Radar: React.FC<React.PropsWithChildren<Props>> = ({ data, options }) => {
  const chartRef = useRef<HTMLCanvasElement>(null);
  const chart = useRef<Chart>();

  useEffect(() => {
    if (!chartRef.current) {
      return;
    }
    const context = chartRef.current.getContext('2d');
    if (!context) {
      return;
    }

    chart.current = new Chart(context, {
      data,
      type: 'radar',
      options,
    });

    return () => {
      chart.current?.destroy();
    };
  }, [data, options]);

  return (
    <StyledChart className="radar">
      <canvas className="chart-canvas" ref={chartRef} />
    </StyledChart>
  );
};

export default Radar;
